// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promocode{overflow:hidden}.promocode__title{font-weight:700;font-size:30px;line-height:34px;color:var(--z2kad5)}@media only screen and (min-width:992px){.promocode__title{font-weight:900;font-size:40px;line-height:48px}}.promocode__title span{color:var(--16604g1)}", ""]);
// Exports
module.exports = exports;
